import { defineStore, StoreDefinition } from "pinia";
import {
    getNotifications,
    getUnreadNotifications,
    markAllAsRead,
    markAsRead,
} from "@/util/notifications";

export const useNotificationStore: StoreDefinition = defineStore(
    "notification-store",
    {
        state: (): {
            notifications: {
                loaded: any[];
                total: number;
                totalPages: number;
            };
            unread: {
                loaded: any[];
                total: number;
                totalPages: number;
            };
            unreadCount: number;
        } => ({
            notifications: {
                loaded: [],
                total: 0,
                totalPages: 0,
            },
            unread: {
                loaded: [],
                total: 0,
                totalPages: 0,
            },
            unreadCount: 0,
        }),
        actions: {
            async fetch(fetch: Promise<any>) {
                const res = await fetch;
                if (res) {
                    const map = res.data.map((n: any) => {
                        return {
                            id: n.id,
                            user_id: n.notifiable_id,
                            type: n.type,
                            data: n.data,
                            read: n.read_at != null,
                            created_at: n.created_at,
                        };
                    });

                    return {
                        loaded: map,
                        total: res.total,
                        totalPages: res.last_page,
                    };
                }
            },
            async load() {
                let res = await this.fetch(getNotifications({ page: 1 }));
                if (res) {
                    this.notifications = res;
                }

                res = await this.fetch(getUnreadNotifications({ page: 1 }));
                if (res) {
                    this.unread = res;
                }
            },
            async paginate(page: number) {
                const res = await this.fetch(getNotifications({ page }));
                if (res) {
                    this.notifications = {
                        loaded: this.notifications.loaded.concat(res.loaded),
                        total: res.total,
                        totalPages: res.totalPages,
                    };
                }
            },
            async paginateUnread(page: number) {
                const res = await this.fetch(getUnreadNotifications({ page }));
                if (res) {
                    this.unread = {
                        loaded: this.unread.loaded.concat(res.loaded),
                        total: res.total,
                        totalPages: res.totalPages,
                    };
                }
            },
            async markAsRead(index: number) {
                const notification: any = this.unread.loaded[index];
                if (notification) {
                    await markAsRead(notification.id);
                }
            },

            async clearAll() {
                await markAllAsRead();
            },
        },
    },
);
